goog.provide("shadow.js.shim.module$$mui$material$ClickAwayListener$default");
shadow.js.shim.module$$mui$material$ClickAwayListener$default = shadow.js.shim.module$$mui$material$ClickAwayListener.default;
